import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDialogOpen, setLoggedInUserAccount, setViewingUserAccount } from '../../../store/Actions';
import { useLocation, useNavigate } from 'react-router-dom';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FancyButton } from '../../common/buttons';
import { FancyTextField } from '../../common/inputs';
import { MyAvatar } from '../../common/MyAvatar';
import { storeUserAccount, getUserAccount } from '../../../firebase/Firestore';

export function Account() {
    const loggedInUser = useSelector(state=>state.loggedInUser);
    const loggedInUserAccount = useSelector(state=>state.loggedInUserAccount);
    const [displayName, setDisplayName] = useState(loggedInUserAccount.displayName);
    const [username, setUsername] = useState(loggedInUserAccount.username);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const saveAccount = async () => {
        const nextUsername = username.trim();
        const nextDisplayName = displayName.trim();
        if(!nextUsername){
            alert('please enter a username');
            return;
        }
        if(!nextDisplayName){
            alert('please enter a display name');
            return;
        }
        const existingAccount = nextUsername.toLowerCase() !== loggedInUserAccount.username.toLowerCase()
            ? await getUserAccount(nextUsername)
            : null;
        if(existingAccount && existingAccount.id !== loggedInUserAccount.id){
            alert('username exists try something else.');
            return;
        }
        const updatedUserAccount = {
            ...loggedInUserAccount,
            displayName: nextDisplayName,
            username: nextUsername
        }
        await storeUserAccount(loggedInUser.uid, updatedUserAccount);
        dispatch(setLoggedInUserAccount(updatedUserAccount))
        dispatch(setViewingUserAccount(updatedUserAccount))
        navigate({
            pathname: `/${encodeURIComponent(nextUsername)}`,
            search: location.search,
        }, { replace: true });
        dispatch(setDialogOpen(''));
    }

    return (
        <>
            <DialogTitle>My Account</DialogTitle>
            <DialogContent style={{flex:1, width:'400px'}}>
                <div style={{display:'flex', flexDirection:'column'}}>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                        <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'start'}}>
                            <div style={{fontWeight:600, marginRight:'10px'}}>Profile Picture</div>
                            <MyAvatar userAccount={loggedInUserAccount}/>
                        </div>
                        <FancyButton
                            onClick={()=>dispatch(setDialogOpen('Update Account Avatar', {parentDialog: 'Account', dialogTitle: 'Update Your Profile Picture'}))}
                        >
                            Update Profile Picture
                        </FancyButton>
                    </div>
                    <FancyTextField
                        label="Display Name"
                        fullWidth
                        style={{marginTop:'20px'}}
                        value={displayName}
                        onChange={(event) => setDisplayName(event.target.value)}
                    />
                    <FancyTextField
                        label="Username"
                        fullWidth
                        style={{marginTop:'20px'}}
                        value={username}
                        onChange={(event) => setUsername(event.target.value)}
                    />
                </div>
                
            </DialogContent>
            <DialogActions style={{display:'flex', flexDirection:'row', justifyContent:'space-between', padding:'20px', paddingLeft:'24px', paddingRight:'24px'}}>
                <FancyButton onClick={()=>dispatch(setDialogOpen(''))}>Cancel</FancyButton>
                <FancyButton variant="dark" onClick={saveAccount}>Save</FancyButton>
            </DialogActions>
        </>
    );
}
